import React from "react";
import PropTypes from "prop-types";
import classes from "./river_info.module.scss";
import ChooseRiver from "./components/chooseRiver/chooseRiver";
import ArticleMin from "./components/articleMin/articleMin";

const RiverInfo = (props) => {
  return (
    <div className={classes.riverInfo}>
      <ChooseRiver />
      <ArticleMin />
    </div>
  );
};

RiverInfo.propTypes = {
  //products: PropTypes.array
};

export default RiverInfo;
